import { render, staticRenderFns } from "./EditorV2ModifyMini.vue?vue&type=template&id=a9a82480"
import script from "./EditorV2ModifyMini.vue?vue&type=script&lang=js"
export * from "./EditorV2ModifyMini.vue?vue&type=script&lang=js"
import style0 from "./EditorV2ModifyMini.vue?vue&type=style&index=0&id=a9a82480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports